import * as _ from 'underscore';
import * as $ from 'jquery';

import { safeTemplate } from './template';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase, { IParameterFieldBaseOptions, IValidator } from './ParameterFieldBase';
import * as Utilities from './Utilities';
import { IWidgetStoreState } from './BaseWidgetStore';
import { config } from '../../../pdc-platform/src/ts/config';

export interface IValuesCollection {
    [field: string]: any;
}

export interface IVariable<TParamOptions extends IParameterFieldBaseOptions = {}> {
    id: string;
    param: ParameterFieldBase<TParamOptions>;
    section: string;
    group?: string;
    deps?: string[];
    merger?(src, obj);
    isArray?: boolean;
    isObject?: boolean;
    hidden?: boolean | ((...params) => boolean);
    prohibitClearable?: boolean;
    prohibitInheritedIcon?: boolean;
}

export interface IVarsDict {
    [id: string]: {
        inherit: string[];
        section: string;
        merger?(src, obj);

        param?: {
            title?: string;
        };
    };
}

export interface ISection {
    id: string;
    name: string;
    parent?: string;
    children?: ISection[];
    expandable?: boolean;
    vars?: IVariable[];
    groups?: IGroup[];
    themeType?: string;
    _themeType?: string;
    visibility?: string[];
    explanation?: string;
    hiddenOptions?: any; //LL: 10.09.19
    dontSortChildren?: boolean; //LL: 26.05.20
    alwaysFirst?: boolean; //LL: 19.07.21

    preview?: Element[] | React.JSX.Element[] | any;
    previewClassName?: string;
}

export interface ISectionsDict {
    [id: string]: ISection;
}

export interface IGroup {
    id: string;
    name: string;
    explanation?: string; //LL: 19.02.20
    section: string;
    vars?: IVariable[];
}

export interface IGroupDict {
    [id: string]: IGroup;
}

export interface ITemplate {
    template(...data: any[]): string;
    levels: any[];
}

export interface IThemeTypesHash {
    [id: string]: {
        title: string;
    };
}

export interface IThemeTypesVisibility {
    [id: string]: string[];
}

export const state: {
    vars?: IVariable[];
    varsDict?: IVarsDict;
    sections?: ISection[];
    sectionsDict?: ISectionsDict;
    groups?: IGroup[];
    groupsDict?: IGroupDict;
    templates?: ITemplate[];
    themeTypes?: string[];
    themeTypesHash?: IThemeTypesHash;
    themeTypesVisibility?: IThemeTypesVisibility;
} = {};

//declare var pdc: any;

var _vars: IVariable[] = (state.vars = []);
var _varsDict: IVarsDict = (state.varsDict = {});

var _sections: ISection[] = (state.sections = []);
var _sectionsDict: ISectionsDict = (state.sectionsDict = {});

var _groups: IGroup[] = (state.groups = []);
var _groupsDict: IGroupDict = (state.groupsDict = {});

var _preRender = [];

var _templates: ITemplate[] = (state.templates = []);

var _themeTypes: string[] = (state.themeTypes = []);
var _themeTypesHash: IThemeTypesHash = (state.themeTypesHash = {});
var _themeTypesVisibility: IThemeTypesVisibility = (state.themeTypesVisibility = {});

export const THEME_ID_LIST_FIELD_NAME = '_keys';

export function registerVars(variables: IVariable[]) {
    var add = _.filter(variables, (obj) => {
        if (_varsDict[obj.id] != null) {
            return false;
        }
        return true;
    });

    _varsDict = _.extend(_varsDict, _.indexBy(add, 'id'));

    _.each(add, (obj) => {
        var section = _sectionsDict[obj.section];

        if (section == null) {
            return;
        }

        if (section.vars == null) {
            section.vars = [];
        }

        section.vars.push(obj);

        if (obj.group != null) {
            var group = _groupsDict[obj.group];

            if (group != null) {
                if (group.vars == null) {
                    group.vars = [];
                }

                group.vars.push(obj);
            }
        }

        _.each(obj.deps, (id) => {
            const dep = _varsDict[id];
            if (dep == null) {
                return;
            }

            if (dep.inherit == null) {
                dep.inherit = [];
            }

            dep.inherit.push(obj.id);
        });
    });

    _vars.push.apply(_vars, add);
}

function registerThemeType(name: string, visibility: string[]) {
    _themeTypes.push(name);

    _themeTypesHash[name] = {
        title: name
    };

    _.each(visibility, (id) => {
        if (_themeTypesVisibility[id] == null) {
            _themeTypesVisibility[id] = [];
        }

        var arr = _themeTypesVisibility[id];

        arr.push(name);
    });
}

export function registerSections(sections: ISection[]) {
    var add = _.filter(sections, (obj) => {
        if (_sectionsDict[obj.id] != null) {
            //console.log("registerSections _sectionsDict[obj.id] != null " + obj.id);
            return false;
        }

        return true;
    });

    _sectionsDict = _.extend(_sectionsDict, _.indexBy(add, 'id'));

    _.each(add, (obj) => {
        obj.children = [];

        if (obj.themeType != null) {
            registerThemeType(obj.themeType, obj.visibility);
        }

        if (obj.parent == null) {
            return;
        }

        var parent = _sectionsDict[obj.parent];

        //LL: 06.02.18
        if (parent == null) {
            //console.log("registerSections parent == null obj.themeType = " + obj.themeType);
            delete obj.parent;
            return;
        }

        if (obj.themeType == null) {
            obj._themeType = parent.themeType || parent._themeType;
        }

        if (parent.children == null) {
            parent.children = [];
        }

        parent.children.push(obj);

        obj = _sectionsDict[obj.id];
        obj.vars = [];
        obj.groups = [];

        //LL: 26.05.20: use dontSortChildren
        if (parent.dontSortChildren != true) {
            //parent.children = _.sortBy(parent.children, 'name');
            //LL: 19.07.21: use alwaysFirst
            parent.children.sort(compare);
        }
    });

    _sections.push.apply(_sections, add);
}

//LL: 19.07.21: used for section 'General Settings for Grids' (id: 'general-widget-grid')
function compare(a: any, b: any) {
    if (!(a.alwaysFirst === true && b.alwaysFirst === true)) {
        if (a.alwaysFirst === true) {
            return -1;
        }
        if (b.alwaysFirst === true) {
            return 1;
        }
    }

    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
}

export function registerGroups(groups: IGroup[]) {
    var add = _.filter(groups, (obj) => {
        if (_groupsDict[obj.id] != null) {
            return false;
        }

        return true;
    });

    _groupsDict = _.extend(_groupsDict, _.indexBy(add, 'id'));

    _.each(add, (obj) => {
        var section = _sectionsDict[obj.section];

        if (section == null) {
            return;
        }

        if (section.groups == null) {
            section.groups = [];
        }

        section.groups.push(obj);

        obj = _groupsDict[obj.id];
        obj.vars = [];
    });

    _groups.push.apply(_groups, add);
}

export function registerPreRender(func) {
    _preRender.push(func);
}

export function registerTemplate(template, levels) {
    template = safeTemplate(template, config.CSP_NONCE);

    _templates.push({
        template: template,
        levels: levels
    });
}

function getVarValue(input: IValuesCollection, vars: IVarsDict, obj, force?: boolean) {
    if (obj == null) {
        return;
    }

    if (vars[obj.id] != null) {
        return vars[obj.id];
    }

    if (force !== true && input[obj.id] != null) {
        return (vars[obj.id] = input[obj.id]);
    }

    // This is IMPORTANTT!!!! ==================================
    var deps = _.map<any, any>(
        obj.deps,

        (id) => {
            return getVarValue(input, vars, _varsDict[id]);
        }
    );
    // ===========================================================

    return (vars[obj.id] = obj.param.getDefault(vars));
}

function calcInheritedRec(res, vars, id, value, input): IVarsDict {
    input[id] = res[id] = value;

    var obj = _varsDict[id];
    if (obj == null) {
        return;
    }

    _.each(obj.inherit, (id) => {
        const inherit = _varsDict[id];
        if (inherit == null) {
            return;
        }

        calcInheritedRec(res, vars, id, getVarValue(input, vars, inherit), input);
    });

    return res;
}

export function calcInherited(id: string, value, input): IVarsDict {
    var res = {};
    var vars = {};

    if (value == null) {
        value = getVarValue(input, vars, _varsDict[id]);
    }

    return calcInheritedRec(res, vars, id, value, _.extend({}, input));
}

export function getThemeObj(input: IValuesCollection): IValuesCollection {
    var vars = {};
    var visited = {};

    if (input == null) {
        input = {};
    }

    _.each(_vars, (obj) => {
        getVarValue(input, vars, obj);
    });

    vars = _.reduce(
        _preRender,

        (result, func: any) => {
            return func(result);
        },

        vars
    );

    return vars;
}

export function getWidgetTheme(moduleName: string, storeState: IWidgetStoreState) {
    const widgetParameters = storeState.data.values[moduleName];

    if (widgetParameters == null) {
        return storeState.options.theme;
    } else {
        //LL: old:
        //const theme = _.extend(
        //    {},
        //    widgetState.options.parentTheme, //widgetState.options.theme,
        //    widgetParameters.theme,
        //    widgetParameters.theme._custom
        //);

        //LL: 06.05.19:
        //LL: color-scales-set is array.  And also entities-model-color-mapping
        //  _.extend is not deep enough.
        // Even $.extend is wrong, merges internal array on "index" basis (is good for entities-model-color-mapping !)

        //LL: 06.05.19:
        let parentTheme = $.extend(true, {}, storeState.options.parentTheme);
        //if (parentTheme != null && parentTheme['color-scales-set-new'] != null) {  // theme[themeVars.color_scales_set]
        //    for (let i = 0; i < parentTheme['color-scales-set-new'].length; i++) {
        //        parentTheme['color-scales-set-new'][i].inherited = true;
        //    }
        //}
        //LL:  $.extend is inside mergeRecursive
        const theme = Utilities.mergeRecursive(
            {},
            parentTheme, //widgetState.options.parentTheme,
            widgetParameters.theme,
            widgetParameters.theme._custom
        );

        //const theme = Utilities.mergeRecursive(
        //    {},
        //    $.extend(true, {}, widgetState.options.parentTheme), //widgetState.options.theme,
        //    $.extend(true, {}, widgetParameters.theme),
        //    $.extend(true, {}, widgetParameters.theme._custom)
        //);

        return getThemeObj(theme);
    }
}

export function clearMapObj(obj) {
    if (obj[THEME_ID_LIST_FIELD_NAME] == null || obj._custom == null) {
        return obj;
    }

    return _.pick(obj, THEME_ID_LIST_FIELD_NAME, '_custom');
}

export function fillMapObj(obj, glob: IGlob) {
    if (obj == null) {
        obj = {};
    }

    if (obj[THEME_ID_LIST_FIELD_NAME] == null) {
        return obj;
    }

    var themesData = glob.ThemeStore.getThemesData();

    return _.extend.apply(
        _,
        [obj].concat(
            _.map(obj[THEME_ID_LIST_FIELD_NAME], (key: string) => {
                return themesData[key];
            })
        )
    );
}

export function refillMapObj(obj, glob: IGlob) {
    return fillMapObj(clearMapObj(obj), glob);
}

export function deserializeReviver(propName, glob: IGlob) {
    return (key, value) => {
        if (key === propName && value != null) {
            return fillMapObj(value, glob);
        }

        return value;
    };
}

export function serializeReplacer(propName: string) {
    return (key, value) => {
        if (key === propName && value != null) {
            return clearMapObj(value);
        }

        return value;
    };
}

function merge(src, obj) {
    var keys = _.chain(obj).keys().without(THEME_ID_LIST_FIELD_NAME, '_custom').value();

    src = _.clone(src);

    return _.reduce(
        keys,
        (res, key: string) => {
            var varObj = _varsDict[key];

            if (varObj == null) {
                return res;
            }

            if (typeof varObj.merger !== 'function' || typeof res[key] === 'undefined') {
                res[key] = obj[key];
            } else {
                res[key] = varObj.merger(res[key], obj[key]);
            }

            return res;
        },
        src
    );
}

export function extend(...objs) {
    return _.reduce(objs, merge, {});
}

export function getThemeType(vars) {
    var res = _.reduce<any, any>(
        _.keys(vars),

        (res, id) => {
            var obj = _varsDict[id];
            if (obj == null) {
                return res;
            }

            var section = _sectionsDict[obj.section];
            if (section == null) {
                return res;
            }

            res[section.themeType || section._themeType] = true;

            return res;
        },

        {}
    );

    return _.keys(res);
}

export function validate(): boolean {
    return (
        _.find(state.vars, (variable) => {
            const param = variable.param;
            if (param != null && param.brokenValidators != null && param.brokenValidators.length > 0) {
                return true;
            }
            return false;
        }) == null
    );
}

//LL:25.08.20: try with param
export function validateState(themeState: any): boolean {
    return (
        _.find(themeState.vars, (variable: any) => {
            const param = variable.param;
            if (param != null && param.brokenValidators != null && param.brokenValidators.length > 0) {
                return true;
            }
            return false;
        }) == null
    );
}

//LL: this validator is used as default in ThemeField and ThemesListField
export const themesValidator: IValidator = () => {
    if (!validate()) {
        return ['Theme data are not valid'];
    }
    return;
};

export function dropBrokenValidators() {
    _.each(state.vars, (variable) => {
        const param = variable.param;
        if (param != null) {
            param.brokenValidators = [];
        }
    });
}

//LL:  PLEASE, DON'T CHANGE IN ANY WAY !!!
//LL: 15.05.20: to use in Chart Axis when they are in Themes
export function mergerForObjects(src, obj) {
    //  src - upper,  obj - own  or src - already exist,  obj - own new

    if (src == null) {
        src = {};
    }

    //LL: remove "null" values:  maybe only for obj ?   (for example, colors may have null values)

    let src2 = _.omit(src, (value, key, object) => {
        return value == null;
    });
    let obj2 = _.omit(obj, (value, key, object) => {
        return value == null;
    });

    //let newObj = $.extend(true, {}, src, obj);
    let newObj = $.extend(true, {}, src2, obj2);

    return newObj;
}

//LL:  PLEASE, DON'T CHANGE IN ANY WAY !!!
//   Used for array-inherited-theme-fields
//LL: 30.09.19: to use in ColorMappingForNumericField, DiscreteMappingField, PalettesField, ChartAxisListField when they are in Themes
export function mergerForArrays(src, obj) {
    //  src - upper,  obj - own  or src - already exist,  obj - own new

    if (src == null) {
        src = [];
    }

    //LL: make copy removing old "disabled" and "another":
    let src2 = _.map(src, (item) => {
        let a: any = _.clone(item);
        return a;
    });
    let obj2 = _.map(obj, (item) => {
        let a: any = _.clone(item);
        return a;
    });

    //LL:  attribute => name
    // remove all color definitions from SRC for attribute that are redefined in OBJ
    let src_1 = _.reject(src2, (src_item: any) => {
        return (
            _.find(obj2, (obj_item: any) => {
                return obj_item.name === src_item.name;
            }) != null
        );
    });

    //LL: set "inherited" to remained SRC:
    _.each(src_1, (item) => {
        item.inherited = true; // new
    });

    // Concat remainders
    return src_1.concat(obj2);
}

//LL:  PLEASE, DON'T CHANGE IN ANY WAY !!!
//   Used for array-inherited-theme-fields
//LL: 23.10.19: to use in render of ColorMappingForNumericField, DiscreteMappingField, PalettesField, ChartAxisListField when they are in Themes
export function getThemeOwnAndParentvalues(props) {
    //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
    let ownValues = [];
    let parentValues = [];

    if (props.options != null) {
        let optionThemeOwnAndParent = props.options.optionThemeOwnAndParent;
        if (optionThemeOwnAndParent != null) {
            if (optionThemeOwnAndParent.ownValue != null) {
                ownValues = optionThemeOwnAndParent.ownValue;
                //console.log("    ownValue.length = " + optionThemeOwnAndParent.ownValue.length);
                //_.each(optionThemeOwnAndParent.ownValue, function (ov: any, key) {
                //    //console.log("    ownValue.name = " + ov.name);
                //});
            }
            if (optionThemeOwnAndParent.parentValue != null) {
                parentValues = optionThemeOwnAndParent.parentValue;
                //console.log("    parentValue.length = " + optionThemeOwnAndParent.parentValue.length);
                //_.each(optionThemeOwnAndParent.parentValue, function (pv: any, key) {
                //    //console.log("    parentValue.name = " + pv.name);
                //});
            }
        }
    }

    return { ownValues: ownValues, parentValues: parentValues };
}

//LL:  PLEASE, DON'T CHANGE IN ANY WAY !!!
//   Used for object-inherited-theme-fields
//LL: 20.05.20: to use in render of ChartAxisField_inThemes, ChartAxisArrayField_inThemes, FontBoxField
export function getThemeOwnAndParentValues_forObjects(props) {
    //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
    let ownValues = {};
    let parentValues = {};

    if (props.options != null) {
        let optionThemeOwnAndParent = props.options.optionThemeOwnAndParent;
        if (optionThemeOwnAndParent != null) {
            if (optionThemeOwnAndParent.ownValue != null) {
                ownValues = optionThemeOwnAndParent.ownValue;
            }
            if (optionThemeOwnAndParent.parentValue != null) {
                parentValues = optionThemeOwnAndParent.parentValue;
            }
        }
    }

    return { ownValues: ownValues, parentValues: parentValues };
}

//LL:  PLEASE, DON'T CHANGE IN ANY WAY !!!
//   Used for array-inherited-theme-fields
//LL: 23.10.19: to use in render of ColorMappingForNumericField, DiscreteMappingField, PalettesField, ChartAxisListField when they are in Themes
export function setProperInheritedFlag(obj, ownValues, parentValues, componentName?) {
    let obj2: any = _.clone(obj);

    //LL: 25.04.19: change in appTheme.merge, so that merger is called always
    //   it works:
    //LL: 24.04.19: to set proper inherited:
    //    Merger works wrong, it seems is called not always when needed.
    //    Merger, it seems, is not called for merging Application Theme Settings and WS Theme
    //LL: also there may be already deleted items, when deleted in Application Theme

    let obj2_truncated: any = _.clone(obj2);
    delete obj2_truncated.inherited;

    //LL:   _.find  -- returning the first one that passes a truth test.  It is obj, not bool
    let in_ownValues = _.find(ownValues, function (item: any) {
        let equalName = item.name === obj2.name;
        if (!equalName) {
            return false;
        }

        // _.isEqual Performs an optimized deep comparison between the two objects, to determine if they should be considered equal.
        let item_truncated: any = _.clone(item);
        delete item_truncated.inherited;

        return _.isEqual(obj2_truncated, item_truncated);
    });

    let nameExistsInParent = false;
    //LL:   _.find  -- returning the first one that passes a truth test.  It is obj, not bool
    let in_parentValues = _.find(parentValues, function (item: any) {
        let equalName = item.name === obj2.name;

        if (!equalName) {
            return false;
        }

        nameExistsInParent = true;
        let item_truncated: any = _.clone(item);
        delete item_truncated.inherited;

        return _.isEqual(obj2_truncated, item_truncated);
    });

    if (in_ownValues == null && in_parentValues == null) {
        // was deleted
        if (obj2.name !== '') {
            //  newly created
            //console.log(" ========= ChartAxisListField render: item was deleted = " + obj2.name);
            console.log(
                ' ===== setProperInheritedFlag: ' +
                    (componentName != null ? componentName : '') +
                    ' render: item was deleted = ' +
                    obj2.name
            );
            return null;
        }
    }

    //LL: 17.02.20: changed inherited  TRY
    //if (in_ownValues != null && in_parentValues != null) {  // changed inherited
    //    if (obj2.inherited === true) {
    //        console.log(" ===== setProperInheritedFlag: " + (componentName != null ? componentName : "") + " render: changed inherited = " + obj2.name);
    //        return null;  //LL: ???
    //    }
    //}

    if (obj2.inherited !== true) {
        if (in_parentValues != null) {
            obj2.inherited = true;
        }
    } else if (obj2.inherited === true) {
        //LL: inherited is set, but item in parent may be changed, so drop inherited
        //    nameExistsInParent ?
        if (in_parentValues == null) {
            delete obj2.inherited;
        }
    }

    return obj2;
}

//   Used for array-inherited-theme-fields
//LL: 17.02.20: with indices
export function getSortedValuesByName(values) {
    //LL:   array of objects with "name" field
    let arr = values.slice(0);
    arr.sort(function (a: any, b: any) {
        let a1 = a.name.toLowerCase();
        let b1 = b.name.toLowerCase();

        //LL: empty - the last:
        if (a1 === '') {
            return 1;
        }
        if (b1 === '') {
            return -1;
        }

        if (a1 > b1) {
            return 1;
        }
        if (a1 < b1) {
            return -1;
        }
        return 0; // a = b
    });

    //return arr;

    let indices = _.map(arr, function (obj: any, i) {
        let j = _.indexOf(values, obj);
        return j;
    });

    return { arr: arr, indices: indices };
}
